import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Routes as AppRoutes } from '../../constants/RouteConstants';
import { getFromStorage } from '../../utils/Helper';
import { StorageConstant } from '../../constants/Constants';
import {
  isSocialProfileGateExemptPath,
  needsSocialProfileCompletion,
  readStoredUserForProfileGate,
} from '../../utils/socialProfileCompletion';

/**
 * Redirects social-login users with incomplete onboarding to the profile completion screen.
 */
export default function SocialProfileGate() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const profileState = useSelector((state: any) => state?.ProfileState);
  const profileUser = profileState?.data?.data ?? readStoredUserForProfileGate();

  useEffect(() => {
    const token = getFromStorage({ key: StorageConstant?.ACCESS_TOKEN });
    if (!token) return;
    if (isSocialProfileGateExemptPath(pathname)) return;

    const user = profileState?.data?.data ?? readStoredUserForProfileGate();
    if (!user) return;

    if (needsSocialProfileCompletion(user)) {
      navigate(AppRoutes.CompleteProfile, { replace: true });
    }
  }, [pathname, navigate, profileState?.data?.data, profileUser?.social_id, profileUser?.account_type]);

  return null;
}
